export const robots = [
    //Scroll down to the bottom of array
  {
    id: 1,
    first_name: "Mayank",
    last_name: "Banga",
    email: "mayankbanga@gmail.com",
  },
  {
    id: 2,
    first_name: "Lakshita",
    last_name: "Bajaj",
    email: " bajaj321@gmail.com",
  },
  { 
    id: 3,
    first_name: "Bhumi", 
    last_name: "Thapa", 
    email: "thapabhumi546@gmail.com" },
  {
    id: 4,
    first_name: "Jasbir",
    last_name: "Singh",
    email: "singh3@yahoo.com",
  },
  {
    id: 5,
    first_name: "Dinesh",
    last_name: "Ragami",
    email: "dinesh67@gmail.com",
  },
  {
    id: 6,
    first_name: "Prachi",
    last_name: "Walia",
    email: "prachiwalia@gmail.com",
  },
  {
    id: 7,
    first_name: "Kalam",
    last_name: "Thapa",
    email: "magar45@gmail.com",
  },
  {
    id: 8,
    first_name: "Shiva",
    last_name: "Roka",
    email: "shivaroka458@gmail.com",
  },
  {
    id: 9,
    first_name: "Abhijeet",
    last_name: "Singh",
    email: "abhijeet458@gmail.com",
  },
  {
    id: 10,
    first_name: "Aman",
    last_name: "Thapa",
    email: "aman45@yahoo.com",
  },


  //add your details here(you can copy the format from github or above)
];
